export { default } from './pharmacy-care-clinic.component';
